import * as React from 'react';
import Tooltip from 'antd/lib/tooltip';

interface SmallStatusNodeProps {
    color: string;
    size?: number;
    isOpenStatusNode?: boolean;
    tooltip?: React.ReactNode;
}

const SmallStatusNode = (props: SmallStatusNodeProps) => {
    const nodeStyle: React.CSSProperties = {
        minHeight: props.size ? props.size : 5,
        minWidth: props.size ? props.size : 5,
        borderRadius: '50%',
    };
    const standardNodeStyle: React.CSSProperties = {
        ...nodeStyle,
        backgroundColor: props.color,
    };

    const openStatusNodeStyle: React.CSSProperties = {
        ...nodeStyle,
        border: '1.5px solid ' + props.color,
    };

    if (props.tooltip) {
        return (
            <Tooltip title={props.tooltip}>
                <div style={props.isOpenStatusNode ? openStatusNodeStyle : standardNodeStyle}></div>
            </Tooltip>
        );
    }
    return <div style={props.isOpenStatusNode ? openStatusNodeStyle : standardNodeStyle}></div>;
};

export default SmallStatusNode;
